/**
 * Extração de imagem colada no chat (Ctrl+V).
 *
 * Um print vindo da ferramenta de captura chega no clipboard como um item
 * `file` de tipo `image/*`, quase sempre acompanhado de um item `text/html`
 * quando a origem é o navegador — por isso não basta olhar o primeiro item.
 */

/** Subconjunto de DataTransferItem que interessa aqui (facilita o teste). */
export interface ClipboardItemLike {
  kind: string;
  type: string;
  getAsFile: () => File | null;
}

const EXTENSION_BY_TYPE: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/bmp': 'bmp',
  'image/svg+xml': 'svg'
};

export function extractImageFromClipboard(
  items: ArrayLike<ClipboardItemLike> | null | undefined
): File | null {
  if (!items) return null;

  for (const item of Array.from(items)) {
    if (item.kind !== 'file' || !item.type.startsWith('image/')) continue;
    const file = item.getAsFile();
    if (file) return file;
  }

  return null;
}

/**
 * O clipboard entrega todo print com o mesmo nome genérico ("image.png"),
 * o que deixa o histórico do chat cheio de anexos indistinguíveis.
 */
export function buildPastedImageName(mimeType: string, now: Date = new Date()): string {
  const extension = EXTENSION_BY_TYPE[mimeType] || 'png';
  const pad = (value: number) => String(value).padStart(2, '0');
  const stamp = [
    now.getFullYear(),
    pad(now.getMonth() + 1),
    pad(now.getDate()),
    pad(now.getHours()),
    pad(now.getMinutes()),
    pad(now.getSeconds())
  ].join('-');

  return `imagem-colada-${stamp}.${extension}`;
}
